import React, { VFC, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
  useDisclosure,
} from '@chakra-ui/react';

type Props = {
  title: string;
  execStr?: string;
  // eslint-disable-next-line
  onExec?: any;
  isLoading?: boolean;
  size?: string;
  children: React.ReactNode;
};

export const CompleteDialog: VFC<Props> = (props) => {
  const navigate = useNavigate();
  const { loginUser } = useLoginUser();
  const toHome = useCallback(() => {
    if (loginUser !== null) {
      // ResetRoute(loginUser);
      // loginUser.routes.push('/home');
      navigate('/reloadURL?url=/home')
    }else{
      navigate('/login.html');
      Auth.signOut();
    }
  }, [navigate,loginUser]);
  const {
    title,
    execStr = 'ホームに戻る',
    onExec = toHome,
    size = 'xl',
    isLoading = false,
    children,
  } = props;
  const { isOpen, onOpen } = useDisclosure();
  const cancelRef = React.useRef<HTMLButtonElement>();

  // 最初の１回だけ描画
  useEffect(() => {
    !isOpen && onOpen();
    //console.log(children);
  }, [isOpen, onOpen]);
  //console.log(children);

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        // eslint-disable-next-line
        leastDestructiveRef={cancelRef as any}
        onClose={onExec}
        isOpen={isOpen}
        isCentered
        closeOnOverlayClick={false}
        size={size}
        allowPinchZoom
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>{title}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>{children}</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              colorScheme="orange"
              ml={3}
              isLoading={isLoading}
              onClick={onExec}
            >
              {execStr}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
